/**
 * Resolve a post-login redirect target from a query param.
 *
 * Only internal absolute paths pass. A protocol-relative value like "//evil.com"
 * is a cross-origin URL to the browser — rejecting it keeps our own login page
 * from becoming an open redirect.
 */
export const resolveRedirect = (raw: unknown): string =>
  typeof raw === "string" && raw.startsWith("/") && !raw.startsWith("//")
    ? raw
    : "/";
